import $ from 'jquery'
import ViewOperation from '@/components/tresorerie/tresorerie/manage-view';
import DateFilter from '@/components/date-filter';

export default {
    name: 'dotation',
    components: {
        ViewOperation, DateFilter
    },
    props: [],
    data() {
        return {
            is_empty: false,
            is_loading: true,
            tresor_fields: [
                { key: 'ligne', label: 'Ligne budgétaire' }, { key: 'alloue', label: 'Montant alloué' },
                { key: 'depense', label: 'Montant dépensé' }, { key: 'reste', label: 'Montant Restant' },
                { key: 'actions', label: 'Action.s' },
            ],

            caisse_fields: [
                { key: 'ligne', label: 'Ligne budgétaire' }, { key: 'alloue', label: 'Montant alloué' },
                { key: 'depense', label: 'Montant dépensé' }, { key: 'reste', label: 'Montant Restant' },
                { key: 'actions', label: 'Action.s' },
            ],

            dotation_histo_fields: [
                'date', 'auteur', 'montant',
            ],

            fields: [
                'date', { key: 'libelle', label: 'Libellé' }, 'montant', { key: 'action', label: 'Action.s' }
            ],
            filter: "",
            perPage: 20,
            currentPage: 1,

            is_loading_1: true,
            is_empty_1: false,

            is_loading_2: true,
            is_empty_2: false,
            save_loading: false,

            modal_title: '',
            ligne_budget: {
                id: 0,
                libelle: '',
                dotation: '',
                source: 0
            },

            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),
            curr_month: {
                id: 0,
                lib: "Filtre par mois"
            },          // Current month of the year
            filter_date: '',
            current_date_filter: {},

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,

            solde_is_less: false,
            can_edit_dotation: true,

            detail_depense_empty: false,
            detail_depense_loading: true,
            dotation_histo_loading: true,
            dotation_histo_empty: false,

            // Total alloué
            tot_alloue_tresor: 0,
            tot_alloue_caisse: 0,

            // Total dépensé
            tot_depense_tresor: 0,
            tot_depense_caisse: 0,

            to_be_deleted: {
				id: 0,
				dotatation: ''
			},
			is_confirm: false,
			del_loading: false,

            view_toggler: 0,
            operation_tresorerie: {
                preuve: '',
                commentaire: ''
            },

            solde_corant_compte_depense: 0,
            solde_compte_depense_loading: true,
            curr_date: ""
        }
    },

    watch: {
        curr_month() {
            var data = {
                month: this.curr_month['id'],
                role_id: 14         // Compte Tresor
            }
            this.getDotations(data)

            const compte_data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                role_id: 14
            }
            this.current_date_filter = compte_data
            this.getSoldeCompteDepense(compte_data)
        },

        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        ligne_budgetaire_caisse() {
            return this.$store.getters['ligne_budgetaire_caisse']
        },

        c_rows() {
            return this.ligne_budgetaire_caisse.length;
        },

        ligne_budgetaire_tresorerie() {
            return this.$store.getters['ligne_budgetaire_tresorerie']
        },

        t_rows() {
            return this.ligne_budgetaire_tresorerie.length;
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
         monthOfYear() {
            let index;
            var m = []
            for (index = 0; index < this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        solde_compte_depense() {
            return this.$store.getters['solde_compte_depense']
        },

        liste_recap_depense_budgetaire_detaille() {
            return this.$store.getters['liste_recap_depense_budgetaire_detaille'];
        },

        d_rows() {
            return this.liste_recap_depense_budgetaire_detaille.length;
        },

        dotation_historique() {
            return this.$store.getters['dotation_historique']
        },

        dot_rows() {
            return this.dotation_historique.length;
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.date.getMonth()]

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
                this.can_view_reglement_dette = true
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.compte_id = 6
            }
        }

        const data = {
            compte_id: this.compte_id,
            user_id: this.userCredentials.user.id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            role_id: 14
        }
        this.curr_date = data

        this.getSoldeCompteDepense()
        // const dot_data = {
        //     month: this.curr_month['id'],
        //     role_id: 14         // Compte Tresor
        // }
        // this.getDotations(dot_data)
    },
    
    methods: {
        viewProof(data) {
            this.view_toggler = (this.view_toggler == 0)?1:0

            this.operation_tresorerie = data
        },

        getSoldeCompteDepense() {
            this.solde_compte_depense_loading = true
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: "",
                one_date: this.setDates().today_date,
                from_date: "",
                to_date: "",
                role_id: 14
            }
            this.$store.dispatch('getSoldeCourantCompteDepense', data).then(() => {
                this.solde_corant_compte_depense = this.solde_compte_depense
                this.solde_compte_depense_loading = false
            })
        },

        getDotations(data) {
            this.tot_alloue_tresor = 0
            this.tot_depense_tresor = 0

            if (data.role_id == 4) {
                this.is_loading_1 = true
            } else if (data.role_id == 14) {
                this.is_loading_2 = true
            }

            this.$store.dispatch('getDotation', data).then(() => {
                this.tot_alloue_tresor = 0
                this.tot_depense_tresor = 0
                if (this.ligne_budgetaire_tresorerie.length > 0) {
                    this.is_empty_2 = false

                    this.ligne_budgetaire_tresorerie.forEach(ligne_budgetaire => {
                        this.tot_alloue_tresor += ligne_budgetaire.total_alloue
                        this.tot_depense_tresor += ligne_budgetaire.total_depense
                    });
                } else {
                    this.is_empty_2 = true
                }
                this.is_loading_2 = false
            })
        },

        edit(data) {
            this.is_edit = true

            this.modal_title = data.libelle
            this.ligne_budget.id = data.ligne_id
            this.ligne_budget.libelle = data.libelle
            this.ligne_budget.source = data.role_id
            this.ligne_budget.dotation = ''
            this.ligne_budget.dotation_id = 0

            this.clearError()
            this.$refs.dotation_form.reset()
        },

        async save() {
            const isValid = await this.$refs.dotation_form.validate();
            if (!isValid) {
                return;
            }

            const montant = parseInt(this.ligne_budget.dotation)

            if (montant > this.solde_compte_depense) {
                this.solde_is_less = true
                return;
            }

            this.save_loading = true

            var data = {
                user_id: this.userCredentials.user.id,
                id: this.ligne_budget.id,
                libelle: this.ligne_budget.libelle,
                source_id: this.ligne_budget.source,
                dotation_id: this.ligne_budget.dotation_id,
                dotation: montant
            }

            this.$store.dispatch('saveDotation', data).then((response) => {
                if (response > 0) {
                    this.$refs.dotation_form.reset()
                    this.$refs.add_dotation.click()

                    const data = {
                        month: this.curr_month['id'],
                        role_id: 14         // Compte Tresor
                    }
                    this.getDotations(data)

                    // const compte_data = {
                    //     compte_id: this.compte_id,
                    //     user_id: this.userCredentials.user.id,
                    //     month: this.curr_month.id,
                    //     one_date: "",
                    //     from_date: "",
                    //     to_date: "",
                    //     role_id: 14
                    // }
                    this.getSoldeCompteDepense()

                    this.successToast("Dotation ajoutée avec succès")
                } else {
                    this.can_edit_dotation = false
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        clearError() {
            this.solde_is_less = false
            this.can_edit_dotation = true
        },

        getDetailDepense(ligne_budgetaire) {
            const data = {
                ligne_budgetaire_id: ligne_budgetaire.ligne_id,
                month: this.curr_month['id'],
            }
            this.modal_title = ligne_budgetaire.libelle

            this.detail_depense_loading = true
            this.$store.dispatch('getListeRecapDepenseBudgetaireDetail', data).then(() => {
                if (this.liste_recap_depense_budgetaire_detaille.length > 0) {
                    this.detail_depense_empty = false 
                } else {
                    this.detail_depense_empty = true 
                }
                this.detail_depense_loading = false
            })
        },

        /**
         * Historique de dotation d'une ligne budgétaire
         */
        getDotationHistorique(v) {
            this.dotation_histo_loading = true
            this.modal_title = v.libelle
            const data = {
                month: this.curr_month['id'],
                ligne_id: v.ligne_id,
                role_id: v.role_id,
            }

            this.$store.dispatch('getHistoriqueDotation', data).then(() => {
                if (this.dotation_historique.length > 0) {
                    this.dotation_histo_empty = false 
                } else {
                    this.dotation_histo_empty = true 
                }
                this.dotation_histo_loading = false
            })
        },

        setToDelete(p) {
            this.is_confirm = false
            this.can_edit_dotation = true
            this.$refs.histo_dotation.click()
            this.to_be_deleted = {
                id: p.dotation_id,
                dotation: p.dotation
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteDotation', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Dotation supprimée avec succès")
                    this.$refs.del_dotation.click()
                    this.is_confirm = false

                    const data = {
                        month: this.curr_month['id'],
                        role_id: 14         // Compte Tresor
                    }
                    this.getDotations(data)

                    // const compte_data = {
                    //     compte_id: this.compte_id,
                    //     user_id: this.userCredentials.user.id,
                    //     month: this.curr_month.id,
                    //     one_date: "",
                    //     from_date: "",
                    //     to_date: "",
                    //     role_id: 14
                    // }
                    this.getSoldeCompteDepense()
                } else {
                    this.can_edit_dotation = false
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}


